module.exports = __webpack_public_path__ + "img/products-2.1b04c64.jpg";